import React, {useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';

import {Heading, Text} from '@edume/magnificent';

import Container from '../../../components/ManagerInsights/Container';
import EmptyState from '../../../components/ManagerInsights/EmptyState';
import Header from '../../../components/ManagerInsights/Header';
import SearchBar from '../../../components/ManagerInsights/SearchBar';
import SearchContainer from '../../../components/ManagerInsights/SearchContainer';
import Tabs from '../../../components/ManagerInsights/Tabs';
import UserDetailCard from '../../../components/ManagerInsights/UserDetailCard';
import * as managerInsightsActions from '../../../state/managerInsights/managerInsightsActions';
import {getManagerInsightsByStore} from '../../../state/managerInsights/managerInsightsSelector';
import {
  avatarFromName,
  formatedDateString,
} from '../../../utils/managerInsightUtils';

import managerInsightsStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const mapStateToProps = (state, ownProps) => {
  const {uid, insightId, managerId} = ownProps.match.params;
  const users = getManagerInsightsByStore(state).get('users').toJS();
  const contents = state.managerInsights.getIn(['insights', 'contents']).toJS();
  const user = users.find((userPar) => userPar.id === Number(uid));

  const {completedContents, noneCompletedContents} = contents.reduce(
    // eslint-disable-next-line no-shadow
    ({completedContents, noneCompletedContents}, currentContent) => {
      const completionDate = currentContent.completedUsers[`${user?.id}`];
      if (completionDate) {
        return {
          completedContents: [
            ...completedContents,
            {...currentContent, completionDate},
          ],
          noneCompletedContents,
        };
      } else {
        return {
          completedContents,
          noneCompletedContents: [...noneCompletedContents, currentContent],
        };
      }
    },
    {completedContents: [], noneCompletedContents: []}
  );

  return {
    details: state.managerInsights.getIn(['insights', 'details']).toJS(),
    user: user,
    completedContents,
    noneCompletedContents,
    insightId,
    managerId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

function UserDetails({
  user,
  completedContents,
  noneCompletedContents,
  goToManagerInsightsTeamPerformance,
  insightId,
  managerId,
}) {
  const [keyword, setKeyword] = useState('');
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    if (!searchMode) {
      setKeyword('');
    }
  }, [searchMode]);

  // if user is not exist in this store we will redirect page to back
  if (!user) {
    goToManagerInsightsTeamPerformance({managerId, insightId});
    return null;
  }

  return (
    <>
      <div className={managerInsightsStyles.view}>
        <div className={managerInsightsStyles.content}>
          <Header
            title={'User details'}
            onClickBack={() =>
              goToManagerInsightsTeamPerformance({managerId, insightId})
            }
          />
          <Container>
            <div
              styleName='user-detail'
              style={{display: searchMode ? 'none' : 'flex'}}
            >
              <div styleName='user-avatar'>
                <Heading
                  as='h2'
                  colour='white'
                  size='leopard'
                  textTransform='none'
                  weight='semiBold'
                >
                  {avatarFromName(user.name)}
                </Heading>
              </div>
              <div styleName='user-info'>
                <Heading
                  as='h2'
                  colour='textPrimary'
                  size='hamster'
                  textTransform='none'
                  weight='semiBold'
                >
                  {user.name}
                </Heading>
                <Text
                  colour='textSecondary'
                  inline='false'
                  lineHeight='tight'
                  size='s'
                  textTransform='none'
                  weight='regular'
                >
                  Joined {formatedDateString(user.createdAt)}
                </Text>
              </div>
            </div>

            <SearchBar
              value={keyword}
              onChange={setKeyword}
              isModeSearch={searchMode}
              onModeChange={setSearchMode}
            />

            {searchMode ? (
              <SearchContainer
                data={[...noneCompletedContents, ...completedContents]}
                keyword={keyword}
                type={'content'}
                searchField={'title'}
                rowRender={(content) => (
                  <UserDetailCard
                    key={content.id}
                    imageUrl={content.image}
                    icon={content.icon}
                    title={content.title}
                    completionDate={
                      content.completionDate
                        ? formatedDateString(content.completionDate)
                        : undefined
                    }
                  />
                )}
              />
            ) : (
              <Tabs
                layz
                items={[
                  {
                    id: '1',
                    title: 'Not Completed',
                    count: noneCompletedContents.length,
                    content: (
                      <>
                        {noneCompletedContents.map((content) => (
                          <UserDetailCard
                            key={content.id}
                            imageUrl={content.image}
                            icon={content.icon}
                            title={content.title}
                          />
                        ))}

                        {!noneCompletedContents.length && (
                          <EmptyState
                            type='content'
                            title='Training not found'
                            description='There is no training assigned to your team'
                          />
                        )}
                      </>
                    ),
                  },
                  {
                    id: '2',
                    title: 'Completed',
                    count: completedContents.length,
                    content: (
                      <>
                        {completedContents.map((content) => (
                          <UserDetailCard
                            key={content.id}
                            imageUrl={content.image}
                            icon={content.icon}
                            title={content.title}
                            completionDate={formatedDateString(
                              content.completionDate
                            )}
                          />
                        ))}

                        {!completedContents.length && (
                          <EmptyState
                            type='content'
                            title='Training not found'
                            description='There is no training assigned to your team'
                          />
                        )}
                      </>
                    ),
                  },
                ]}
              />
            )}
          </Container>
        </div>
      </div>
    </>
  );
}

UserDetails.propTypes = {
  insightId: PropTypes.string.isRequired,
  managerId: PropTypes.string.isRequired,
  goToManagerInsightsTeamPerformance: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  completedContents: PropTypes.array.isRequired,
  noneCompletedContents: PropTypes.array.isRequired,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(CSSModules(UserDetails, styles, {allowMultiple: true})))
);
